import {  OnModuleInit } from '@nestjs/common';


// @Component()
export class BotService implements OnModuleInit{
  onModuleInit() {
    // this.botMessage();
  }
    botMessage(notificationMessage:string) {        
    //     process.env.NTBA_FIX_319 = "1";
        const TelegramBot = require('node-telegram-bot-api');
        //GTPL - Attendance
        const token = '1247215653:AAFhUALl-b8gs2SYdIXIlJ2D9PbH-IbaVa4';
        //vehicle_track
        //const token = '1028108827:AAH-Olb9h1cXuW5T--e7PDexGjXP_PCdrpY';
        // console.log('Message');
        const bot = new TelegramBot(token, { polling: true });
        const opts = {
          // reply_markup:{
          //   keyboard: [
          //     ['FAQ'],
          //     ['Buy']
          //   ]
          // },
          parse_mode: 'Markdown'
        };
        //1604617325 Chat id for Mr.Pavan
        // 181367436 chat id for Mr.Navin
        //655867161 chat id for Pavani
        //1038428010 chat id for Swathi
        //36475226 chat id for Rk
        //1375169538 chat id for Manisha
        const chat_ids=[181367436,36475226,1604617325,1038428010,1375169538];
        // const chat_ids=[1375169538];
        chat_ids.forEach(chat_id => {
          bot.sendMessage(chat_id,notificationMessage,opts);
       
        });
        // bot.sendMessage(36475226,notificationMessage);
        // bot.Message('welcome');
        bot.on('message', (msg) => {
          // console.log('Message');
          // console.log(msg);
          
            let Hi = "hi";
            if (msg.text.toString().toLowerCase().indexOf(Hi) === 0) {
                bot.sendMessage(msg.from.id, "Hello " + msg.from.first_name + " what would you like to know about me ?");
            }
            let One = "one";
            if (msg.text.toString().toLowerCase().indexOf(One) === 0) {
                bot.sendMessage(msg.from.id, "Hello " + msg.from.first_name + " How are you ?");
            }
           
           
        });
      
    }
    sendNotification(){

      const TelegramBot = require('node-telegram-bot-api');
        
      const token = '1247215653:AAFhUALl-b8gs2SYdIXIlJ2D9PbH-IbaVa4';
      // const token = '1028108827:AAH-Olb9h1cXuW5T--e7PDexGjXP_PCdrpY';

      // this.botMessage();
      // const bot1 = new TelegramBot(token, { polling: true });
      // const chat_ids=[36475226,655867161];
      // chat_ids.forEach(chat_id => {
      //   bot1.sendMessage(chat_id,"Message from GTPL Attendance ?");
      // });
    }
}